import * as React from 'react';
import Select, { Option, OptionValues } from 'react-select';
import '../../../styles/FormSelect.css';

export interface Props {
    selectProps: {
        id: string;
        name: string;
        required?: boolean;
        value?: OptionValues;
        disabled?: boolean;
        placeholder?: string;
        clearable?: boolean;
        searchable?: boolean;
        readOnly?: boolean;
    };
    selectOptions: {
        value: OptionValues;
        label: string;
    }[];
    onChange: (inputName: string, newValue?: OptionValues) => void;
    className?: string;
}

const FormSelect = (props: Props) => {
    const selectChanged = (newValue: Option<OptionValues>) => {
        props.onChange(props.selectProps.name, newValue === null ? undefined : newValue.value);
    };

    return (
        <Select
            clearable={false}
            searchable={false}
            {...props.selectProps}
            className={props.className}
            options={props.selectOptions}
            onChange={selectChanged}
            value={props.selectProps.value}           
        />
    );
};

export default FormSelect;



// WEBPACK FOOTER //
// ./src/components/common/form/FormSelect.tsx